export default "__VITE_ASSET__nnfn4bdy__"